import { DateField } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { ITranslateStore } from '../../stores/TranslateStore';
import { DATE_FORMAT, firstDayInEarliestInvoicesYear, now } from '../../util/DateUtil';

interface IFilterDateFieldProps {
  translateStore?: ITranslateStore;
  id: string;
  label: string;
  date: Date;
  onChange: (selectedValue?: Date) => void;
  disableDaySelection?: boolean;
}

@inject('translateStore')
@observer
export default class FilterDateField extends React.Component<IFilterDateFieldProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;

    return (
      <DateField
        // Needs to reinitialize on every re-render because DateField
        // DateField:componentWillReceiveProps sets state when props change. See for details
        // https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-
        //  state.html#anti-pattern-erasing-state-when-props-change
        key={Math.random()}
        id={this.props.id}
        label={this.props.label}
        format={DATE_FORMAT}
        defaultValue={this.props.date}
        datepicker={{
          onSubmit: this.props.onChange,
          onClear: () => this.forceUpdate(),
          range: {
            from: firstDayInEarliestInvoicesYear(),
            to: now()
          },
          clearButtonLabel: translate('invoices.previous-invoices.filter.clear-date'),
          submitButtonLabel: translate('invoices.previous-invoices.filter.set-date'),
          columns: this.props.disableDaySelection ? ['year', 'month'] : undefined
        }}
      />
    );
  }
}
